import React, { useMemo, useState } from "react";
import BottomNav from "../components/BottomNav";
import { ArrowLeft, Clock, CheckCircle2, XCircle } from "lucide-react";
import { formatAZN } from "../utils";

const TABS = [
  { key: "all", label: "Hamısı" },
  { key: "pending", label: "Yoxlanılır" },
  { key: "approved", label: "Təsdiqləndi" },
  { key: "rejected", label: "İmtina" },
];

const statusMeta = {
  pending: { label: "Yoxlanılır", cls: "", Icon: Clock, iconCls: "pending" },
  approved: { label: "Təsdiqləndi", cls: "green", Icon: CheckCircle2, iconCls: "approved" },
  rejected: { label: "İmtina", cls: "red", Icon: XCircle, iconCls: "rejected" },
};

export default function Applications({ go, notify, applications, openDetail }) {
  const [tab, setTab] = useState("all");
  const filtered = useMemo(
    () => (tab === "all" ? applications : applications.filter((a) => a.status === tab)),
    [tab, applications]
  );

  return (
    <section className="screen">
      <div className="topbar">
        <button className="icon-btn" onClick={() => go("home")}>
          <ArrowLeft size={22} />
        </button>
        <div className="section-title">Müraciətlərim</div>
        <span style={{ width: 38 }} />
      </div>
      <div className="content">
        <div className="tabs">
          {TABS.map((t) => (
            <button
              key={t.key}
              className={`tab ${tab === t.key ? "active" : ""}`}
              onClick={() => setTab(t.key)}
            >
              {t.label}
            </button>
          ))}
        </div>

        {filtered.length === 0 && (
          <div style={{ textAlign: "center", color: "#98a2b3", padding: "30px 0", fontSize: 13 }}>
            Bu kateqoriyada müraciət yoxdur
          </div>
        )}

        {filtered.map((app) => {
          const meta = statusMeta[app.status];
          const Icon = meta.Icon;
          return (
            <div
              key={app.id}
              className={`application ${meta.cls}`}
              onClick={() => openDetail(app.id)}
              role="button"
            >
              <div>
                <div>
                  <span className="amt">{formatAZN(app.amount)}</span>{" "}
                  <span className="status">{meta.label}</span>
                </div>
                <p>{app.subtitle}</p>
              </div>
              <div className={`status-icon ${meta.iconCls}`}>
                <Icon size={32} strokeWidth={2} />
              </div>
            </div>
          );
        })}
      </div>
      <BottomNav active="applications" go={go} notify={notify} />
    </section>
  );
}
